import {
  AnalyticsPageName,
  LanguageNameSpaces,
  SubscriptionPlanType,
} from "@shared/types";
import { SECURE_CLIENT_INVITE_HELPER_ARTICLE_ID } from "@shared/features/settings/subscription/constants.ts";
import { HelperTooltip } from "common/Tooltips/HelperTooltip.tsx";
import React from "react";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation";

interface SecureClientInviteHelperTooltipProps {
  planType?: SubscriptionPlanType;
}

const SecureClientInviteHelperTooltip = ({
  planType,
}: SecureClientInviteHelperTooltipProps) => {
  const isCommunityAdmin = planType === SubscriptionPlanType.COMMUNITY_ADMIN;
  const isAssetManager = planType === SubscriptionPlanType.ASSET_MANAGER;
  const { t } = useTypedTranslation(LanguageNameSpaces.PORTFOLIO);

  const description = isCommunityAdmin
    ? t("secure_client_invite.description_community_admin")
    : isAssetManager
    ? t("secure_client_invite.description_asset_manager")
    : t("secure_client_invite.description");

  return (
    <HelperTooltip
      analyticsPageName={AnalyticsPageName.BILLING}
      analyticsFieldName={t("secure_client_invite.field_name")}
      description={description}
      articleId={
        isCommunityAdmin ? "14488639" : SECURE_CLIENT_INVITE_HELPER_ARTICLE_ID
      }
      containerStyle={{ marginLeft: 6 }}
      maxWidth={300}
    />
  );
};

export default SecureClientInviteHelperTooltip;
